export default "__VITE_ASSET__COwVLKNG__"